import { TranslationEventType } from "services/api/translations/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const SETTING_TRANSLATION_SEARCH_COLUMNS: Column[] = [
  {
    title: "admin.settings.search.key",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return <>{row.key}</>;
    },
  },
  {
    title: "admin.settings.search.value",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return <>{row.value}</>;
    },
  },
  {
    title: "admin.settings.search.createdon",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return <>{row.created}</>;
    },
  },
  {
    title: "",
    field: "type",
    type: ColumnTypes.custom,
    render: (row, onEventClick) => {
      return (
        <ButtonMenu endIcon="/media/icons/more-dots.svg"         variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={() => onEventClick(row.id, TranslationEventType.REMOVE)}
          >
            Brisanje prijevoda
          </ButtonMenuItem>
        </ButtonMenu>
      );
    },
  },
];
